"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCustomBulletOptionWrapper = exports.StyledCustomBulletOptionModal = exports.StyledAddButtonWrapper = exports.StyledButtonsGroupContainer = exports.StyledTextButton = exports.StyledRemoveButtonWrapper = exports.StyledOptionTextWrapper = exports.StyledOptionWrapper = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledOptionWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
exports.StyledOptionTextWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  padding-right: ${({ theme }) => theme.Modal.Padding.Large}px;
`;
exports.StyledRemoveButtonWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  margin-left: auto;
`;
exports.StyledTextButton = styled_components_1.default.button `
  display: flex;
  flex: initial;
  min-height: 0;
  background: transparent;
  padding: 0;
  border: none;
  cursor: pointer;

  &[disabled],
  &.disabled {
    color: ${({ theme }) => theme.Color.Neutrals.Text};
`;
exports.StyledButtonsGroupContainer = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
`;
exports.StyledAddButtonWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Button.Size.Large)}`};
  height: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Button.Size.Large)}`};
  border-radius: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Button.Radius.Medium)}`};
  background: ${({ theme }) => theme.Color.Neutrals.Light};
  cursor: pointer;
  transition: all ${({ theme }) => theme.Transition.Timing.Out};

  &:hover {
    background: ${({ theme }) => theme.Color.Neutrals.Border};
  }
`;
exports.StyledCustomBulletOptionModal = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  position: absolute;
  border-radius: ${({ theme }) => theme.Border.Radius.Large}px;
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Light};
  box-shadow: 0 0 8px ${({ theme }) => theme.Color.Overlay.Light};
  left: 0;
  top: 0;
  width: max-content;
  height: max-content;
  padding: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.MediumSmall)}`};
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.MediumSmall)}`};
  z-index: ${({ theme }) => theme.ZIndex.ZIndex.Modal};
  background: ${({ theme }) => theme.Color.Neutrals.Paper};
  text-align: left;
`;
exports.StyledCustomBulletOptionWrapper = styled_components_1.default.div `
  display: flex;
  height: 145px;
  overflow: auto;
  ${({ theme }) => {
    return theme.Scrollbar.Default;
}}
`;
//# sourceMappingURL=Option.style.js.map